jQuery(document).ready(function($) {
  

   var category_button = $('#current_category');
   var cat_menu = $('#l-campus__menu');
   category_button.on('click',function() {
      if(cat_menu.hasClass('l-campus__menu__list__ul--open')) {
         category_button.removeClass('l-campus__menu__list__current--open');
         cat_menu.removeClass('l-campus__menu__list__ul--open');
      } else {
         cat_menu.addClass('l-campus__menu__list__ul--open');
         category_button.addClass('l-campus__menu__list__current--open');
      }
    
   });
});
